module.exports = __webpack_public_path__ + "resources/img/img_i_onenet_jp.cd706ef1b9357c1eeb5bd06e84eb7da2.png";